import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './LinkTalentPage.module.css';
import { useIntl } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useSelector } from 'react-redux';
import { currentUserListingSelector, userSelector } from '../../ducks/user.duck';
import LinkTalentPanel from './LinkTalentPanel';
import { getUserType } from '../../util/userDataExtraction';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
const LinkTalentPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const scrollingDisabled = useSelector(isScrollingDisabled);
  const currentUser = useSelector(userSelector);
  const userType = getUserType(currentUser);
  const currentUserListing = useSelector(currentUserListingSelector);
  const pageTitle = intl.formatMessage({
    id: 'LinkTalentPage.title',
  });

  return (
    <Page title={pageTitle} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <LinkTalentPanel
          currentUser={currentUser}
          intl={intl}
          currentUserListing={currentUserListing}
          userType={userType}
          history={history}
          routeConfiguration={routeConfiguration}
        />
      </LayoutSingleColumn>
    </Page>
  );
};

export default LinkTalentPage;
